import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 60,
  height = 60,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || "0 0 60 60"}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.5752 22.644C33.7468 22.644 33.0752 21.9725 33.0752 21.144V11.608C33.0752 10.7796 33.7468 10.108 34.5752 10.108C35.4036 10.108 36.0752 10.7796 36.0752 11.608V21.144C36.0752 21.9725 35.4036 22.644 34.5752 22.644Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.177 42.7991C22.112 43.625 21.3899 44.2419 20.564 44.177C17.8877 43.9665 15.4646 43.4291 13.6603 42.6333C12.7616 42.237 11.9426 41.7444 11.3264 41.1336C10.7052 40.5178 10.2014 39.6858 10.2014 38.6687L10.2014 11.6078C10.2014 10.7794 10.873 10.1078 11.7014 10.1078C12.5299 10.1078 13.2014 10.7794 13.2014 11.6078L13.2014 38.6687L13.2015 38.67C13.2016 38.6708 13.2019 38.6729 13.2028 38.6766C13.2045 38.6836 13.2094 38.6999 13.2224 38.7264C13.2494 38.7812 13.3103 38.876 13.4384 39.003C13.7034 39.2657 14.1665 39.5778 14.8709 39.8885C16.2727 40.5067 18.3398 40.9928 20.7991 41.1862C21.625 41.2511 22.2419 41.9733 22.177 42.7991Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.0757 11.6C33.0758 11.6 33.0757 11.6012 33.0753 11.6035C33.0754 11.6012 33.0756 11.6 33.0757 11.6ZM33.0744 11.6079C33.0665 11.6435 33.0138 11.7979 32.7047 12.0596C32.3114 12.3926 31.654 12.7603 30.712 13.0987C28.8409 13.7707 26.1609 14.2158 23.1385 14.2158C20.116 14.2158 17.436 13.7707 15.565 13.0987C14.623 12.7603 13.9656 12.3926 13.5722 12.0596C13.2632 11.7979 13.2105 11.6435 13.2025 11.6079C13.2105 11.5724 13.2632 11.418 13.5722 11.1563C13.9656 10.8233 14.623 10.4556 15.565 10.1172C17.436 9.44519 20.116 9.00005 23.1385 9.00005C26.1609 9.00005 28.8409 9.44519 30.712 10.1172C31.654 10.4556 32.3114 10.8233 32.7047 11.1563C33.0137 11.418 33.0665 11.5724 33.0744 11.6079ZM13.2012 11.6C13.2013 11.6 13.2015 11.6012 13.2016 11.6035C13.2012 11.6012 13.2012 11.6 13.2012 11.6ZM13.2016 11.6124C13.2015 11.6147 13.2013 11.6159 13.2012 11.6159C13.2012 11.6159 13.2012 11.6147 13.2016 11.6124ZM33.0753 11.6124C33.0757 11.6147 33.0758 11.6159 33.0757 11.6159C33.0756 11.6159 33.0754 11.6147 33.0753 11.6124ZM31.7261 15.9221C29.4536 16.7383 26.4152 17.2158 23.1385 17.2158C19.8617 17.2158 16.8234 16.7383 14.5509 15.9221C13.4211 15.5163 12.4004 14.9984 11.6336 14.3491C10.8742 13.706 10.2017 12.7858 10.2017 11.6079C10.2017 10.4301 10.8742 9.50986 11.6336 8.86683C12.4004 8.21756 13.4211 7.69965 14.5509 7.29385C16.8234 6.47759 19.8617 6.00005 23.1385 6.00005C26.4152 6.00005 29.4536 6.47759 31.7261 7.29385C32.8559 7.69965 33.8765 8.21756 34.6433 8.86683C35.4027 9.50986 36.0752 10.4301 36.0752 11.6079C36.0752 12.7858 35.4028 13.706 34.6433 14.3491C33.8765 14.9984 32.8559 15.5163 31.7261 15.9221Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.8458 53.7839C33.3962 53.5123 33.1214 53.0253 33.1214 52.5V35.4789C33.1214 34.6504 33.793 33.9789 34.6214 33.9789C35.4499 33.9789 36.1214 34.6504 36.1214 35.4789L36.1214 50.017L46.7988 44.4048L46.7988 28.3114C46.7988 27.4829 47.4704 26.8114 48.2988 26.8114C49.1273 26.8114 49.7988 27.4829 49.7988 28.3114L49.7988 45.311C49.7988 45.8682 49.4899 46.3795 48.9967 46.6388L35.3193 53.8278C34.8544 54.0722 34.2954 54.0555 33.8458 53.7839Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.3977 53.7839C34.9481 54.0555 34.3892 54.0722 33.9242 53.8278L20.2468 46.6388C19.7536 46.3795 19.4447 45.8682 19.4447 45.311L19.4447 28.3114C19.4447 27.4829 20.1162 26.8114 20.9447 26.8114C21.7731 26.8114 22.4447 27.4829 22.4447 28.3114L22.4447 44.4048L33.1221 50.017L33.1221 35.4789C33.1221 34.6504 33.7936 33.9789 34.6221 33.9789C35.4505 33.9789 36.1221 34.6504 36.1221 35.4789L36.1221 52.5C36.1221 53.0253 35.8473 53.5123 35.3977 53.7839Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.3177 36.8074C34.8816 37.0359 34.3612 37.0359 33.9252 36.8074L20.2478 29.6399C19.7536 29.3809 19.444 28.8691 19.444 28.3112C19.444 27.7534 19.7536 27.2416 20.2478 26.9826L33.9252 19.8152C34.3612 19.5867 34.8816 19.5867 35.3177 19.8152L48.9951 26.9826C49.4892 27.2416 49.7988 27.7534 49.7988 28.3112C49.7988 28.8691 49.4892 29.3809 48.9951 29.6399L35.3177 36.8074ZM45.0672 28.3113L34.6214 22.8373L24.1756 28.3113L34.6214 33.7853L45.0672 28.3113Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
